var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',[_c('div',{staticClass:"desc"},[_vm._v(" 心理健康對對碰！請將正確答案放在問題當中，即可獲得1分！ ")]),_c('div',{staticClass:"button",on:{"click":function($event){return _vm.$emit('ready')}}},[_vm._v("Ready")])])}
var staticRenderFns = []

export { render, staticRenderFns }